import type { BstockCreditDto } from '@b-stock/erp-api-client'
import type {
  BalancePortalLinkResult,
  PayMethod,
  StartQualificationRequest,
  StartQualificationResponse,
  SearchInvoiceResponseDto,
} from '@b-stock/payments-methods-api-client'

import appConfig from '@config/config'
import { get, deleteReq, post } from '@helpers/xhr'

const { api } = appConfig

export default {
  async fetchPaymentMethods({
    params,
    entityId,
  }: {
    params: { [key: string]: string }
    entityId: string
  }) {
    const { data } = await get<PayMethod[]>(api.payments.entities, params, {
      entities: { entityId },
    })
    return data
  },

  async deletePaymentMethod({ id }: { id: string }) {
    const { data } = await deleteReq<PayMethod>(
      api.payments.methods,
      undefined,
      {
        entities: { id },
      }
    )
    return data
  },

  async setPaymentMethodAsDefault({ id }: { id: string }) {
    const { data } = await post<PayMethod>(
      api.payments.makePrimary,
      undefined,
      {
        entities: { id },
      }
    )
    return data
  },

  async fetchBstockCredit({ accountId }: { accountId: string }) {
    const { data } = await get<BstockCreditDto>(
      api.payments.credit.balance,
      null,
      { entities: { accountId } }
    )
    return data
  },

  async startNetTermsBalanceQualification(
    payload: StartQualificationRequest
  ): Promise<StartQualificationResponse> {
    const { data } = await post<StartQualificationResponse>(
      api.netTermsBalance.startQualification,
      payload
    )
    return data
  },

  async getBalancePortalLink(
    balanceBuyerId: string
  ): Promise<BalancePortalLinkResult> {
    const { data } = await get<BalancePortalLinkResult>(
      api.netTermsBalance.getBalancePortalLink,
      null,
      { entities: { balanceBuyerId } }
    )
    return data
  },

  async searchBalanceInvoices(
    balanceBuyerId: string,
    params?: {
      page?: number
      limit?: number
      sortBy?: string
      'filter.status'?: string
    }
  ): Promise<SearchInvoiceResponseDto> {
    const { data } = await get<SearchInvoiceResponseDto>(
      api.netTermsBalance.searchInvoices,
      params,
      { entities: { balanceBuyerId } }
    )
    return data
  },

  async fetchPaymentMethodToken({
    buyerAccountId,
  }: {
    buyerAccountId: string
  }): Promise<string> {
    const { data } = await get<{ token: string }>(
      api.balance.paymentMethodToken,
      null,
      { entities: { buyerAccountId } }
    )
    return data.token
  },
}
